// extracted by mini-css-extract-plugin
export default {"lineDot":"css_lineDot__mzBZ2","lineDotInner":"css_lineDotInner__ya-y1"};